/* Native Shopify cart AJAX enhancement; falls back to the ordinary cart/add POST. */
(() => {
  'use strict';
  const root = () => window.Shopify?.routes?.root || '/';
  function initForms(context=document){
    context.querySelectorAll('[data-najah-add-form]').forEach(form=>{
      if(form.dataset.productBound)return;form.dataset.productBound='1';
      // Keep optional quantity entered on the landing page for the product page.
      if(document.body.classList.contains('template-product')){
        const qs=new URLSearchParams(window.location.search);
        const qty=Number(qs.get('quantity'));
        const field=form.querySelector('[name="quantity"]');
        if(field && Number.isInteger(qty) && qty>=1 && qty<=20)field.value=String(qty);
      }
      form.addEventListener('submit',async e=>{
        const btn=form.querySelector('[data-add-cart]');
        const input=form.querySelector('[name="id"]');
        if(!input || !input.value){e.preventDefault();window.NajahUI?.toast('اختار الحجم قبل إضافة الباقة.');return;}
        const quantity=Number(form.querySelector('[name="quantity"]')?.value||1);
        if(!Number.isInteger(quantity) || quantity<1 || quantity>20){e.preventDefault();window.NajahUI?.toast('اختار كمية بين 1 و 20');return;}
        // NAJAH BAC quick-COD flow: never add to cart on the landing page.
        // Navigate to the Shopify product's actual selected variant so Releasit
        // can render in its supported product-page context.
        if(form.hasAttribute('data-najah-cod-redirect')){
          e.preventDefault();
          const handle=form.dataset.productHandle;
          if(!handle || !/^[a-zA-Z0-9-]+$/.test(handle)){
            window.NajahUI?.toast('تعذر العثور على رابط الباقة.');return;
          }
          const target=new URL(root()+'products/'+encodeURIComponent(handle),window.location.origin);
          target.searchParams.set('variant',input.value);
          target.searchParams.set('quantity',String(quantity));
          target.hash='najah-cod-start';
          const purchaseSection = document
  .getElementById('najah-purchase')
  ?.closest('.shopify-section');

const codForm =
  document.querySelector('[id*="__apps"]') ||
  purchaseSection?.nextElementSibling;

if (codForm) {
  codForm.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
} else {
  window.NajahUI?.toast('استمارة الطلب غير موجودة في الصفحة');
}
          return;
        }
        if(!('fetch' in window))return;
        e.preventDefault();const original=btn?.textContent;
        if(btn){btn.disabled=true;btn.textContent='جاري الإضافة...';}
        try{
          const fd=new FormData(form);
          const res=await fetch(root()+'cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});
          const data=await res.json();
          if(!res.ok)throw new Error(data.description || 'تعذرت إضافة المنتج.');
          window.NajahUI?.toast('تمت إضافة الباقة للسلة. تقدر تفتح السلة وتكمل الطلب.');
          await window.NajahUI?.refreshCartCount();
        }catch(error){window.NajahUI?.toast(error.message||'تعذر الطلب، حاول مرة أخرى.');}
        finally{if(btn){btn.disabled=false;btn.textContent=original;}}
      });
    });
    context.querySelectorAll('[data-native-variant-select]').forEach(select=>{
      if(select.dataset.bound)return;select.dataset.bound='1';
      select.addEventListener('change',()=>{
        const option=select.selectedOptions[0];
        const price=Number(option?.dataset.price);
        const priceNode=document.querySelector('.product-detail__price');
        if(priceNode && price>=0)priceNode.textContent=window.NajahUI.money(price);
        const btn=select.closest('form')?.querySelector('[data-add-cart]');if(btn)btn.disabled=option.disabled;
        // Only synchronize globally if matching a A4/A5 variant in the featured product.
        const v=window.NajahVariant?.product?.variants?.find(v=>String(v.id)===select.value);
        if(v){const m=v.title.match(/A[45]/i);if(m)window.NajahVariant.select(m[0].toUpperCase());}
      });
    });
  }
  document.addEventListener('DOMContentLoaded',()=>initForms());
  document.addEventListener('shopify:section:load',e=>initForms(e.target));
})();
